import WebServiceRequest from '../Api/WebServiceRequest'

class GetAllMedias extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setTag(`Files/GetList`)
  }

  setParams(data) {
    super.setRequestParam(data)
  }
}
class MediaCreateFileRequest extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setTag(`Files/Create`)
  }

  setForm(data) {
    super.setFormData(data)
  }
}
export {
  GetAllMedias,
  MediaCreateFileRequest
}
